/** Zahlen, Daten und Kennungen so, wie eine Kanzlei sie liest. */

export function euro(cent: string | bigint | null | undefined, mitVorzeichen = false): string {
  if (cent === null || cent === undefined || cent === '') return '—'
  const wert = typeof cent === 'bigint' ? cent : BigInt(cent)
  const negativ = wert < 0n
  const abs = negativ ? -wert : wert
  const ganz = (abs / 100n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  const rest = (abs % 100n).toString().padStart(2, '0')
  const zeichen = negativ ? '−' : mitVorzeichen ? '+' : ''
  return `${zeichen}${ganz},${rest}`
}

export function datum(iso: string | null | undefined): string {
  if (!iso) return '—'
  const [j, m, t] = iso.slice(0, 10).split('-')
  return `${t}.${m}.${j}`
}

export function zeitpunkt(iso: string | null | undefined): string {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

export function zeitraum(von: string | null | undefined, bis: string | null | undefined): string {
  if (!von && !bis) return 'Zeitraum fehlt'
  return `${datum(von)} bis ${datum(bis)}`
}

export function iban(wert: string | null | undefined): string {
  if (!wert) return '—'
  return wert.replace(/(.{4})/g, '$1 ').trim()
}

export const STAND_TEXT: Record<string, string> = {
  pruefen: 'zu prüfen',
  bereit: 'bereit',
  freigegeben: 'freigegeben',
  doppelt: 'doppelt',
  exportiert: 'exportiert',
  wartet: 'wartet',
  wird_gelesen: 'wird gelesen',
  fehler: 'Fehler',
}

/** Eine Kreditkarte, wie sie in Listen steht: nur die Endziffern der maskierten Nummer. */
export function karteKurz(beleg: string | null): string {
  const ende = (beleg ?? '').replace(/[^0-9]/g, '').slice(-4)
  return ende ? `Karte ···· ${ende}` : 'Karte'
}
